import { makeStyles } from '@material-ui/core'
import axios from 'axios';
import React from 'react'
import { TrendingCoins } from '../config/api';
import { CryptoState} from '../CryptoContext';
import { useState, useEffect } from 'react';
import AliceCarousel from 'react-alice-carousel';
import { Link } from 'react-router-dom';
const useStyles=makeStyles({
    carousel: {
     display:'flex',
     height:'50%',
     alignItems:'center',
     paddingBottom:'30px'
    },
    carouselItems:{
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        cursor:'pointer',
        color:'white'
    }
  })
  const numberwithcommas=(x)=>{
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  
const Carousel = () => {
    const{currency,symbol}=CryptoState();
    const classes=useStyles();
    const [trending, settrending] = useState([])
    const fetchingtrendingcoins= async()=>{
       const {data}=await axios.get(TrendingCoins(currency));
       settrending(data);
      
    }
    // console.log(trending)
   useEffect(() => {
       fetchingtrendingcoins();
   }, [currency])
   
 const  responsive={
    0: {
        items: 1,
    },
    1024: {
        items: 4
    }
   }
   const items= trending.map((coin)=>{
      
        return ( 
            <>
     <Link to={`/coin/${coin.id}`} className={classes.carouselItems} > 
    
     <img src={coin.image} alt={coin.name} height='80' style={{marginBottom:'10px'}} />
    <span>{coin.symbol}  <span  style={{color:'red'}}> { coin.price_change_percentage_24h.toFixed(2) }% </span>  </span> 
    <p style={{fontSize:'22px',fontWeight:'bold'}} > {symbol} {numberwithcommas(coin.current_price)}  </p>
     </Link>
      
      
       
       
       
        
      </>   )
       })
   
  return (
    <div className={classes.carousel} >
        <AliceCarousel
          mouseTracking
          infinite
          autoPlayInterval={1000}
          animationDuration={1500}
          responsive={responsive}
          autoPlay
          disableButtonsControls
          disableDotsControls
          items={items}
        />
    </div>
  )
}

export default Carousel;